export const ROLE_GVA_ADMIN = 'GVA.Admin';
export const ROLE_GVA_USER = 'GVA.User';
export const ROLE_HK_ADMIN = 'HK.Admin';
export const ROLE_HK_USER = 'HK.User';
export const ROLE_UK_ADMIN = 'UK.Admin';
export const ROLE_UK_USER = 'UK.User';

export const CIGP_COLORS = [
  '#56725A',
  '#5A7865',
  '#5F7E71',
  '#63837D',
  '#678789',
  '#6C858E',
  '#708294',
  '#757F99',
  '#797B9F',
  '#847EA5',
  '#9282AA',
  '#A086B0',
  '#AE8BB5',
  '#BB8FB8',
  '#C094B3',
  '#C698AE',
  '#CB9DA9',
  '#D1A1A3',
  '#D6AFA6',
  '#DCBFAB',
  '#E1CFAF'
];

// Navigation style enum and preferred style constant
export enum NavigationStyle {
  Top = 'top',
  SideBar = 'sidebar',
  Both = 'both'
}

export const PREFERRED_NAVIGATION_STYLE: NavigationStyle = NavigationStyle.Top;

export const GRAPH_API = {
  endpoint: 'https://graph.microsoft.com/v1.0',
  consentScopes: ['User.Read']
};
